import { FEATURE_GIFT_WRAP } from 'constants/features';
import GiftBag from 'components/icons/GiftBag';
import { cn } from 'helpers/classnames';
import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';

interface GiftWrapIndicatorProps {
  className?: string;
  giftMessage?: string;
  giftWrapped?: boolean;
}

// Three variants: gift bag + message, gift bag only, or message only.
const getLabel = (giftWrapped?: boolean, giftMessage?: string) => {
  if (!giftWrapped) {
    return 'Gift message';
  }
  return giftMessage ? 'Gift bag with message — $3.00' : 'Gift bag — $3.00';
};

export const GiftWrapIndicator = ({ className, giftMessage, giftWrapped }: GiftWrapIndicatorProps) => {
  const { isEnrolled } = useIsEnrolledInVariant({ featureFlag: FEATURE_GIFT_WRAP });

  if (!isEnrolled || (!giftWrapped && !giftMessage)) {
    return null;
  }

  return (
    <div className={cn('flex text-primary', giftMessage ? 'items-start' : 'items-center', className)}>
      <GiftBag className="mr-1 h-auto w-6 shrink-0" />
      <div className="flex flex-col">
        <span className="font-medium">{getLabel(giftWrapped, giftMessage)}</span>
        {/* TODO(FEE-8522): Phase 2 — giftMessage is populated once the Account API returns it, and the hardcoded $3.00 becomes the real giftWrapCharge (CARE dependency). */}
        {giftMessage && <span className="mt-1 text-secondary">&ldquo;{giftMessage}&rdquo;</span>}
      </div>
    </div>
  );
};

export default GiftWrapIndicator;
